module.exports = __webpack_public_path__ + "img/global.82649458.svg";